import React from 'react'
import ReactDOM from 'react-dom'
import './main.css'

import Routes from './routes.js'

ReactDOM.render(<Routes />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js